import { useEffect, useMemo } from 'react';
import {
  FormLabel,
  Heading,
  HStack,
  Input,
  Switch,
  Spacer,
  VStack,
} from '@chakra-ui/react';

import debounce from 'lodash/debounce';

import { Search } from '../../assets';
import { getDataTracking } from '../../utils';

export interface DonationFilterProps {
  onChanged: (val: string) => void;
  onToggleThanked: () => void;
}

export const DonationFilter = (props: DonationFilterProps) => {
  const { onChanged, onToggleThanked } = props;
  const onSearchChange = (e: any) => {
    const val = e.target.value;
    onChanged(val);
  };

  // Type ahead does not need to render the UI as fast as the user types, but it does
  // need to be responsive. 400ms is an ideal compromise.
  const onDebouncedSearchChange = useMemo(
    () => debounce(onSearchChange, 400),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Make sure debouncer is not called after component is ummounted
  useEffect(
    () => () => onDebouncedSearchChange.cancel(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <VStack align="stretch" spacing={3}>
      <VStack spacing={2} align="stretch">
        <HStack spacing={2}>
          <Search color="brand.monochromatic.700" />
          <Heading color="brand.monochromatic.700" fontSize="md">
            Search Donors
          </Heading>
        </HStack>

        <Input aria-label="searchDonors" onChange={onDebouncedSearchChange} />
      </VStack>

      <HStack w="full">
        <FormLabel
          className="wrapable"
          htmlFor="showUnthankedOnly"
          mb="0"
          mt="0.25rem"
        >
          Show Unthanked Only
        </FormLabel>

        <Spacer />

        <Switch
          aria-label="showUnthankedOnly"
          mt="0.25rem"
          id="showUnThankedOnly"
          onChange={() => onToggleThanked()}
          colorScheme="green"
          size="lg"
          {...getDataTracking('showUnthankedOnlySwitch')}
        />
      </HStack>
    </VStack>
  );
};
